import { createSelector, createDraftSafeSelector } from '@reduxjs/toolkit'
import type { HorizontalTimelineState } from './reducers/index'

export const createHorizontalTimelineSelector = createSelector.withTypes<HorizontalTimelineState>()
export const createHorizontalTimelineDraftSelector = createDraftSafeSelector.withTypes<HorizontalTimelineState>()
